import { Injectable } from '@angular/core';
import { ApiService } from '../..';
import { Jsonp, RequestOptions, Http, Headers, ResponseContentType } from '@angular/http';
@Injectable()
export class BaocaoxulyrfgprsService {
  constructor(
    public api: ApiService
  ) { }
  APIURL_Chung = "api/ExcuteOracle"
  //Lấy báo cáo thống kê
  public P_LayNguonLoi(maloi) {
    var param = {
      "config": '{"namesql":"PKG_BAOCAOXULY_RF.P_LAY_NGUONLOI","connstr":"Amiss42"}',
      "para": '{"v_maloi":"' + maloi + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  public P_LayLoaiLoi(nguonloi, loailoi) {
    var param = {
      "config": '{"namesql":"PKG_BAOCAOXULY_RF.P_LAY_LOAILOI","connstr":"Amiss42"}',
      "para": '{"v_maloi":"' + nguonloi + '","v_phanloai":"' + loailoi + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  /****Thống kê xử lý******************* */
  public P_thongkexuly(danhmucid, phanloai, tungay, denngay, mataikhoan) {
    var param = {
      "config": '{"namesql":"PKG_BAOCAOXULY_RF.P_THONGKEXULY","connstr":"Amiss42"}',
      "para": '{"v_danhmucid":"' + danhmucid + '","v_phanloai":"' + phanloai + '","v_tungay":"' + tungay + '","v_denngay":"' + denngay + '","v_mataikhoan":"' + mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  thongkexuly_exportExcel(danhmucid, phanloai, tungay, denngay, mataikhoan, tendonvi, tenchucnang, noidungbaocao, thoigian) {
    let columns = [
      { "name": "rnum", "label": "STT", "horizontalalignment": "center" },
      { "name": "tenloi", "label": "Phân loại lỗi", "horizontalalignment": "left" },
      { "name": "soluong", "label": "Tổng điểm xử lý", "horizontalalignment": "right" },
      { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },

    ];
    let fileName = tendonvi + "_" + tenchucnang + "_" + thoigian + ".xlsx";
    let config = JSON.stringify({ namesql: "PKG_BAOCAOXULY_RF.P_THONGKEXULY", connstr: "Amiss42" });
    let para: any = JSON.stringify({
      v_danhmucid: danhmucid,
      v_phanloai: phanloai,
      v_tungay: tungay,
      v_denngay: denngay,
      v_mataikhoan: mataikhoan
    });
    var param = {
      config: config,
      para: para,
      title: noidungbaocao,
      header: tendonvi + "_" + thoigian,
      filename: "",
      sheets: tenchucnang,
      columns: columns,
      data: ""
    };

    return this.api.downloadFile("api/ExportExcelRF", param, fileName);
  }

  saveExcel(danhmucid, phanloai, tungay, denngay, mataikhoan, tendonvi, tenchucnang, noidungbaocao, thoigian) {
    let columns = [
      { "name": "rnum", "label": "STT", "horizontalalignment": "center" },
      { "name": "tenloi", "label": "Phân loại lỗi", "horizontalalignment": "left" },
      { "name": "soluong", "label": "Tổng điểm xử lý", "horizontalalignment": "right" },
      { "name": "tyle", "label": "Tỷ lệ (%)", "horizontalalignment": "right" },

    ];
    let dateNow = new Date();
    let strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();
    let fileName = tendonvi + "_" + tenchucnang + "_" + strDate + ".xlsx";
    let config = JSON.stringify({ namesql: "PKG_BAOCAOXULY_RF.P_THONGKEXULY", connstr: "Amiss42" });
    let para: any = JSON.stringify({
      v_danhmucid: danhmucid,
      v_phanloai: phanloai,
      v_tungay: tungay,
      v_denngay: denngay,
      v_mataikhoan: mataikhoan
    });

    var param = {
      config: config,
      para: para,
      title: noidungbaocao + "_" + tendonvi + "_" + strDate,
      header: "",
      filename: fileName,
      sheets: tenchucnang,
      columns: columns,
      data: "",
      mataikhoan: mataikhoan,
      danhmucid: danhmucid,
      loaibaocao: 2,
      tenbaocao: "Báo cáo xử lý GPRS",
    };

    return this.api.Excute("api/SaveExcel", param);
  }
  thongKeChiTietXuLy_saveExcel(danhmucid, phanloai, nguonloi, loailoi, tungay, denngay, mataikhoan, thietbimoi, pageNum, numRecs, tendonvi, tenchucnang, noidungbaocao, thoigian) {
    let columns = [
      { "name": "rnum", "label": "STT", "horizontalalignment": "center" },
      { "name": "dienluc", "label": "Điện lực", "horizontalalignment": "left" },
      { "name": "tentram", "label": "Tên trạm", "horizontalalignment": "left" },
      { "name": "tinhtrangtruocxuly", "label": "Tình trạng trước xử lý", "horizontalalignment": "left" },
      { "name": "cachxuly", "label": "Cách xử lý", "horizontalalignment": "left" },
      { "name": "loaithietbi", "label": "Loại thiết bị", "horizontalalignment": "left" },
      { "name": "mathietbimoi", "label": "Mã thiết bị mới", "horizontalalignment": "left" },
      { "name": "versionmoi", "label": "Version mới", "horizontalalignment": "center" },
      { "name": "mathietbicu", "label": "Mã thiết bị cũ", "horizontalalignment": "left" },
      { "name": "versioncu", "label": "Version cũ", "horizontalalignment": "center" },
      { "name": "nguyennhanloi", "label": "Nguyên nhân lỗi", "horizontalalignment": "left" },
      { "name": "ketquaxuly", "label": "Kết quả xử lý", "horizontalalignment": "left" },
      { "name": "nhanvienxuly", "label": "Nhân viên xử lý", "horizontalalignment": "left" },
      { "name": "ngayxuly", "label": "Ngày xử lý", "horizontalalignment": "left" },
      { "name": "kenh", "label": "Kênh", "horizontalalignment": "left" },
      { "name": "barcode", "label": "Barcode", "horizontalalignment": "left" },
      { "name": "ghichu", "label": "Ghi chú", "horizontalalignment": "left" }
    ];
    let para: any = JSON.stringify({
      v_danhmucid: danhmucid,
      v_phanloai: phanloai,
      v_nguonloi: nguonloi,
      v_loailoi: loailoi,
      v_tungay: tungay,
      v_denngay: denngay,
      v_mataikhoan: mataikhoan,
      v_thietbimoi: thietbimoi,
      v_pagenum: pageNum,
      v_numrecs: numRecs
    });
    let config = JSON.stringify({ namesql: "PKG_BAOCAOXULY_RF.P_THONGKECHITIETXULY", connstr: "Amiss42" });
    let dateNow = new Date();
    let strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();
    let fileName = tendonvi + "_" + tenchucnang + "_" + strDate + ".xlsx";
    var param = {
      config: config,
      para: para,
      title: noidungbaocao + "_" + tendonvi + "_" + strDate,
      header: "",
      filename: fileName,
      sheets: tenchucnang,
      columns: columns,
      data: "",
      mataikhoan: mataikhoan,
      danhmucid: danhmucid,
      loaibaocao: 3,
      tenbaocao: "Báo cáo chi tiết xử lý GPRS",
    };

    return this.api.Excute("api/SaveExcel", param);
  }

  /***Thống kê chi tiết xử lý*************** */
  public P_ThongKeChiTietXuLy(danhmucid, phanloai, nguonloi, loailoi, tungay, denngay, mataikhoan, thietbimoi, pageNum, numRecs) {
    var param = {
      "config": '{"namesql":"PKG_BAOCAOXULY_RF.P_THONGKECHITIETXULY","connstr":"Amiss42"}',
      "para": '{"v_danhmucid":"' + danhmucid + '","v_phanloai":"' + phanloai + '","v_nguonloi":"' + nguonloi + '","v_loailoi":"' + loailoi + '","v_tungay":"' + tungay + '","v_denngay":"' + denngay + '","v_mataikhoan":"' + mataikhoan + '","v_thietbimoi":"' + thietbimoi + '","v_pagenum":"' + pageNum + '","v_numrecs":"' + numRecs + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  thongKeChiTietXuLy_exportExcel(danhmucid, phanloai, nguonloi, loailoi, tungay, denngay, mataikhoan, thietbimoi, pageNum, numRecs, tendonvi, tenchucnang, noidungbaocao, thoigian) {
    let columns = [
      { "name": "rnum", "label": "STT", "horizontalalignment": "center" },
      { "name": "dienluc", "label": "Điện lực", "horizontalalignment": "left" },
      { "name": "tentram", "label": "Tên trạm", "horizontalalignment": "left" },
      { "name": "tinhtrangtruocxuly", "label": "Tình trạng trước xử lý", "horizontalalignment": "left" },
      { "name": "cachxuly", "label": "Cách xử lý", "horizontalalignment": "left" },
      { "name": "loaithietbi", "label": "Loại thiết bị", "horizontalalignment": "left" },
      { "name": "mathietbimoi", "label": "Mã thiết bị mới", "horizontalalignment": "left" },
      { "name": "versionmoi", "label": "Version mới", "horizontalalignment": "center" },
      { "name": "mathietbicu", "label": "Mã thiết bị cũ", "horizontalalignment": "left" },
      { "name": "versioncu", "label": "Version cũ", "horizontalalignment": "center" },
      { "name": "nguyennhanloi", "label": "Nguyên nhân lỗi", "horizontalalignment": "left" },
      { "name": "ketquaxuly", "label": "Kết quả xử lý", "horizontalalignment": "left" },
      { "name": "nhanvienxuly", "label": "Nhân viên xử lý", "horizontalalignment": "left" },
      { "name": "ngayxuly", "label": "Ngày xử lý", "horizontalalignment": "left" },
      { "name": "kenh", "label": "Kênh", "horizontalalignment": "left" },
      { "name": "barcode", "label": "Barcode", "horizontalalignment": "left" },
      { "name": "ghichu", "label": "Ghi chú", "horizontalalignment": "left" }
    ];
    let para: any = JSON.stringify({
      v_danhmucid: danhmucid,
      v_phanloai: phanloai,
      v_nguonloi: nguonloi,
      v_loailoi: loailoi,
      v_tungay: tungay,
      v_denngay: denngay,
      v_mataikhoan: mataikhoan,
      v_thietbimoi: thietbimoi,
      v_pagenum: pageNum,
      v_numrecs: numRecs
    });
    let config = JSON.stringify({ namesql: "PKG_BAOCAOXULY_RF.P_THONGKECHITIETXULY", connstr: "Amiss42" });
    return this.api.exportExcel("", columns, para, config, tendonvi, tenchucnang, noidungbaocao, thoigian);
  }
  /****Nhập thông tin *************/
  uploadExcelReturnJson(desFolder: string, overWrite: string, file: File) {
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    formData.append('Desfolder', desFolder);
    formData.append('overWrite', overWrite);
    let headers = new Headers()
    //headers.append('Content-Type', 'json');  
    //headers.append('Accept', 'application/json');  
    let options = new RequestOptions({ headers: headers });
    return this.api.Excute("api/NhapXuLyRF/UploadExcelReturnJson", formData, options);
  }
  getDataCmissBulk(jsonData, mataikhoan, ip) {
    let formData: FormData = new FormData();
    formData.append('namesql', "PKG_BAOCAOXULY_RF.SAVE_NHAPTHONGTINRF");
    formData.append('jsondata', jsonData);
    formData.append('mataikhoan', mataikhoan);
    formData.append('ip', ip);
    return this.api.Excute("api/NhapXuLyRF/GetDataCmisBulk", formData);
  }
  f_savethongtinxulybangtay(dienluc, tentram, tinhtrangtruocxuly, cachxuly, loaithietbi,
    mathietbicu, versioncu, mathietbimoi, versionmoi, nguyennhanloi, ketquaxuly, nhanvienxuly
    , ngayxuly, kenh, barcode, ghichu, mataikhoan) {
    var param = {
      "config": '{"namesql":"PKG_BAOCAOXULY_RF.SAVETHONGTINXULYBANGTAY","connstr":"Amiss42"}',
      "para": '{"v_dienluc":"' + dienluc + '","v_tentram":"' + tentram + '","v_tinhtrangtruocxuly":"' + tinhtrangtruocxuly + '","v_cachxuly":"' + cachxuly + '","v_loaithietbi":"' + loaithietbi + '","v_mathietbicu":"' + mathietbicu + '","v_versioncu":"' + versioncu + '","v_versionmoi":"' + versionmoi + '","v_mathietbimoi":"' + mathietbimoi + '","v_nguyennhanloi":"' + nguyennhanloi + '","v_ketquaxuly":"' + ketquaxuly + '","v_nhanvienxuly":"' + nhanvienxuly + '","v_ngayxuly":"' + ngayxuly + '","v_kenh":"' + kenh + '","v_barcode":"' + barcode + '","v_ghichu":"' + ghichu + '" ,"v_mataikhoan":"' + mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }


}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/bao-cao-xu-ly-rf-gprs/baocaoxulyrfgprs.service.ts